module.exports = "/_next/static/images/Hero-ed480203783e54701b1abf503a0c6e48.webp";